import { useParams } from "react-router-dom"
import "./guide.css"
import flagList from "./data.json"
import { useEffect, useState } from "react";
import { GuideDetailModal } from "./GuideDetail";
import { AiOutlineClose } from 'react-icons/ai';
import { sheetMap } from "./sheetMap"

const CollapsibleList = ({ title, content }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  if (!content) return null;

  const items = content.split('\n').map(item => item.trim()).filter(Boolean);
  if (items.length === 0) return null;

  const maxItems = 1;
  const maxCharLength = 120;

  const hasTooManyItems = items.length > maxItems;
  const hasVeryLongItem = items.some(item => item.length > maxCharLength);
  const isTooLong = hasTooManyItems || hasVeryLongItem;

  let displayedItems = items;
  if (!isExpanded && isTooLong) {
    displayedItems = items.slice(0, maxItems).map(item => {
      if (item.length > maxCharLength) {
        return item.substring(0, maxCharLength) + "...";
      }
      return item;
    });
  }

  return (
    <div className="collapsible-section mb-3">
      <p className="fw-bold mb-1">{title} :</p>
      <ul>
        {displayedItems.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      {isTooLong && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="btn-see-more"
        >
          {isExpanded ? "See Less" : "See More"}
        </button>
      )}
    </div>
  );
};

export const CardUniv = (props) => {
  const { city } = useParams(); // dari route: /guide/:city
  const [data, setData] = useState([]);

  const baseUrl = 'https://docs.google.com/spreadsheets/d/1cIS6Hp2MO5Gp9PkYQ-ysC9twXvZCyCwNaa_-HHmJLZ8/gviz/tq?tqx=out:json&gid=';

  useEffect(() => {
    const gid = sheetMap[city?.toLowerCase()];
    if (!gid) return;

    const fetchData = async () => {
      try {
        const res = await fetch(baseUrl + gid);
        const text = await res.text();
        const json = JSON.parse(text.substring(47).slice(0, -2));
        const rows = json.table.rows.map(row => {
          const cells = row.c.map(cell => (cell ? cell.v : ''));
          return {
            institution: cells[0],
            country: cells[1],
            price: cells[2],
            level: cells[3],
            benefit: cells[4],
            advantage: cells[5],
            id: cells[6],
          };
        });
        // console.log(rows)
        // setData(rows);
        setData(rows.slice(1));
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    fetchData();
  }, [city]);

  const getFlagByCountry = (countryName) => {
    if (!countryName) return null;
    const countries = countryName.split(/,|&/).map(c => c.trim()).filter(Boolean);

    if (countries.length > 1) {
      const worldFlag = flagList.find(item => item.country === 'World');
      return worldFlag ? `/flags/${worldFlag.flagImg}` : '/flags/world.png';
    }

    // Case: Banyak Negara / 20+ Negara
    if (
      countryName === 'Banyak Negara (100 Kampus)' ||
      countryName === '20+ Negara' ||
      countryName === 'Europe' ||
      countryName === 'Asia' ||
      countryName === 'NIEC Indonesia'
    ) {
      const worldFlag = flagList.find(item => item.country === 'NIEC');
      return worldFlag ? `/flags/${worldFlag.flagImg}` : '/flags/niec-fg.webp';
    }

    // Case: Niece Indonesia
    // if (countryName === 'NIEC Indonesia') {
    //   const worldFlag = flagList.find(item => item.country === 'Indonesia');
    //   return worldFlag ? `/flags/${worldFlag.flagImg}` : '/flags/in-fg.jpg';
    // }

    // Default single flag
    const found = flagList.find(f => f.country.toLowerCase() === countryName.toLowerCase());
    return found ? `/flags/${found.flagImg}` : null;
  };

  const [selectedItem, setSelectedItem] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsOpen(false);
      setIsClosing(false);
    }, 300);
  };

  const postQueue = (item) => {
    if (window.sendToFlutter && window.sendToFlutter.postMessage) {
      window.sendToFlutter.postMessage(
        JSON.stringify({ action: 'postQueue', value: item.id })
      );
    } else {
      console.warn('unavailable sendToFlutter — please access via WebView Flutter');
    }
  };

  return (
    <>
      {data.map((item, index) => {
        const flagSrc = getFlagByCountry(item.country);
        return (
          <div key={index} className="blur m-3 m-md-4  p-2 p-md-3" onClick={() => { setIsOpen(true); setSelectedItem(item); }}>
            <div className="row align-items-center">
              <div className="col-8">
                <div className="">
                  <h6 className="univ-title">{item.institution.toUpperCase()}</h6>
                </div>
                <div>Price : {item.price}</div>
                <div>Level : {item.level}</div>
              </div>
              <div className="col-4">
                <p className="">{item.country}</p>
                {Array.isArray(flagSrc) ? (
                  flagSrc.map((src, index) => (
                    <img
                      key={index}
                      src={src}
                      alt={`flag-${index}`}
                      width={50}
                      className="img-border mb-2"
                    />
                  ))
                ) : (
                  <img
                    src={flagSrc}
                    alt={`flag-of-${item.country}`}
                    width={50}
                    className="img-border"
                  />
                )}
              </div>
            </div>
            <div className="mt-3">
              <button className="btn-rm" onClick={(e) => {
                e.stopPropagation();
                postQueue(item);
              }}>
                Ambil Nomor Antrian
              </button>
            </div>
          </div>
        )
      })}

      <GuideDetailModal isOpen={isOpen} isClosing={isClosing} onClose={handleClose}>
        {selectedItem && (
          <div className="position-relative default-detail">
            <button
              onClick={handleClose}
              className="btn position-absolute top-0 end-0 m-2"
              style={{ zIndex: 10 }}
              aria-label="Close"
            >
              <AiOutlineClose />
            </button>
            <h2 className="univ-title mt-5">{selectedItem.institution}</h2>
            <CollapsibleList title="Benefit" content={selectedItem.benefit} />
            <CollapsibleList title="Advantage" content={selectedItem.advantage} />
            <div className="mt-5">
              <button className="btn-que-2" onClick={(e) => {
                e.stopPropagation();
                postQueue(selectedItem);
              }}>
                Ambil Nomor Antrian
              </button>
            </div>
          </div>
        )}
      </GuideDetailModal>
    </>
  )
}